import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiUrl } from '../constants/api-url';

export interface TermsAndConditionStatus {
  isAccepted: boolean;
  isToggleOn: boolean;
}

@Injectable({ providedIn: 'root' })
export class TermsAndConditionService {
  private httpClient = inject(HttpClient);

  // Once the user accepts in this session we remember it. The accept POST and the
  // guard's status GET are not read-after-write consistent, so a status GET fired
  // immediately after accept() can still return isAccepted=false, bouncing the user
  // back to the T&C page until the backend/cache catches up (the "stuck until reload
  // 1-2 times" symptom). Trusting this flag avoids the race.
  private acceptedThisSession = false;

  get hasAcceptedThisSession(): boolean {
    return this.acceptedThisSession;
  }

  getStatus(): Observable<TermsAndConditionStatus> {
    return this.httpClient.get<TermsAndConditionStatus>(ApiUrl.IS_TERMS_AND_CONDITION_ACCEPTED);
  }

  accept(): Observable<any> {
    return this.httpClient.post(ApiUrl.ACCEPT_TERMS_AND_CONDITION, null).pipe(
      tap(() => { this.acceptedThisSession = true; })
    );
  }
}
